import { core_user_notifications } from './ModelCoreUserNotifications'

export const coreUserNotificationModels = {
  core_user_notifications,
}

export * from './ModelCoreUserNotifications'
